import React from 'react';
import PropTypes from 'prop-types';
import { IntegerInput } from '@fmm/react-encompass-inputs';
import { useAutosavingFormContext } from 'src/components/ConnectedInputs/AutosavingForm';
import { Controller } from 'react-hook-form';

export const ConnectedNumberInput = React.forwardRef(
  (
    { name, rules, decimalLimit, required, id, allowNullOrEmpty, sx, ...props },
    ref,
  ) => {
    const { id: contextId } = useAutosavingFormContext();

    return (
      <Controller
        name={name}
        rules={{
          required,
          ...rules,
        }}
        render={({
          field: { value, onChange, onBlur },
          fieldState: { invalid, error },
        }) => (
          <IntegerInput
            id={(id ?? contextId) ? `${contextId}.${name}` : name}
            variant='outlined'
            size='small'
            fullWidth
            {...props}
            sx={{
              '& .MuiInputAdornment-root': {
                color: 'var(--text-dark-2) !important',
              },
              '& .MuiInputAdornment-root .MuiTypography-root': {
                color: 'inherit !important',
              },
              '& .MuiInputBase-root.Mui-disabled .MuiInputAdornment-root': {
                color: 'var(--text-dark-3) !important',
              },
              '& .MuiInputBase-root.Mui-disabled .MuiInputAdornment-root .MuiTypography-root':
                {
                  color: 'inherit !important',
                },
              '& .MuiInputBase-root.Mui-disabled .MuiInputBase-input': {
                color: 'var(--text-dark-3) !important',
                WebkitTextFillColor: 'var(--text-dark-3) !important',
              },
              '& .MuiInputBase-root.Mui-disabled .MuiOutlinedInput-notchedOutline':
                {
                  borderColor: 'var(--text-dark-4) !important',
                },
              ...sx,
            }}
            decimalLimit={decimalLimit}
            name={name}
            value={value ?? ''}
            onChange={(e) => {
              let value = e.target.value;
              if (allowNullOrEmpty && (value === null || value === '')) {
                // let's us reset field instead of setting to 0
                onChange(value);
              } else if (e.target.value !== '') value = +value;
              onChange(value);
            }}
            onBlur={onBlur}
            ref={ref}
            error={invalid}
            helperText={error?.message}
            required={Boolean(required || rules?.required)}
          />
        )}
      />
    );
  },
);

export default ConnectedNumberInput;
ConnectedNumberInput.displayName = 'ConnectedNumberInput';
ConnectedNumberInput.defaultProps = {
  decimalLimit: 2,
};
ConnectedNumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.object,
  decimalLimit: PropTypes.number,
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool,
  allowNullOrEmpty: PropTypes.bool,
  id: PropTypes.string,
  sx: PropTypes.object,
};
